/*eslint-disable*/
import React, { useState } from "react";
import "../../Assests/Globalcss/stylesheet.css";
import Navbar from "../../Componenets/Navbar";
import Footer from "../../Componenets/Footer";
import { useNavigate } from "react-router-dom";
import CalculatorModal from "../../Componenets/CalculatorModal";

const employees = localStorage.getItem("employees");
const program = localStorage.getItem("program");

const index = () => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  const handleCalculateClick = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <Navbar />
      {showModal && (
        <CalculatorModal
          showModal={showModal}
          setShowModal={setShowModal}
          handleCloseModal={handleCloseModal}
        />
      )}
      <section class="banner-section">
        <div class="container">
          <div class="row">
            <div class="col-xl-12 col-lg-9 col-md-12">
              <div class="hme_bnr_text mt-3">
                <h1 className="">
                  Strategic Resources For
                  <span> Growing Your Business</span>
                </h1>
              </div>
            </div>
            <div class="col-md-12 col-lg-7"></div>
          </div>
        </div>
      </section>

      <section class="banner-bottom-cards bg-light">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12">
              <a onClick={() => navigate("/grants")}>
                <div class="solution_cards_box">
                  <div class="solution_card">
                    <div class="hover_color_bubble"></div>
                    <div class="so_top_icon text-center">
                      <i class="fa-solid fa-circle-plus text-center mb-3"></i>
                    </div>
                    <div class="solu_title">
                      <h4 class="text-center">Grants</h4>
                    </div>
                    <div class="solu_description">
                      <p class="elementor-icon-box-description text-center">
                        Browse and apply for a wide variety of small business
                        grant opportunities.
                      </p>
                    </div>
                    <div class="w-100 text-center">
                      <button
                        class="cardbtun btn btn-w text-center m-auto mt-2 nav-link nav-btn_dii"
                        data-button="button1"
                        style={{ cursor: "pointer", padding: "6px" }}
                      >
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            <div class="col-lg-6 col-md-6 col-sm-12">
              <a onClick={() => handleCalculateClick()}>
                <div class="solution_cards_box">
                  <div class="solution_card">
                    <div class="hover_color_bubble"></div>
                    <div class="so_top_icon text-center">
                      <i class="fa-solid fa-heart-pulse text-center mb-3"></i>
                    </div>
                    <div class="solu_title">
                      <h4 class="text-center">Health Programs</h4>
                    </div>
                    <div class="solu_description">
                      <p class="elementor-icon-box-description text-center">
                        Retain your good employees with excellent benefits.
                      </p>
                    </div>
                    <div class="w-100 text-center">
                      <button class="cardbtun btn btn-w text-center m-auto mt-2">
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default index;
